import { DEV } from 'esm-env';
import { render_effect, teardown } from '../../../reactivity/effects.js';
import { listen_to_event_and_reset_event } from './shared.js';
import * as e from '../../../errors.js';
import { is } from '../../../proxy.js';
import { queue_micro_task } from '../../task.js';
import { hydrating } from '../../hydration.js';
import { is_runes, untrack } from '../../../runtime.js';

/**
 *
 *
 *
 *
 */
export function bind_value(input, get, set = get) {
	var runes = is_runes();

	listen_to_event_and_reset_event(input, 'input', (is_reset) => {
		if (DEV && input.type === 'checkbox') {
			/*                                   */
			e.bind_invalid_checkbox_value();
		}

		/*              */
		var value = is_reset ? input.defaultValue : input.value;
		value = is_numberlike_input(input) ? to_number(value) : value;
		set(value);

		/*                                                                                */
		/*                                                                        */
		if (runes && value !== (value = get())) {
			var start = input.selectionStart;
			var end = input.selectionEnd;

			/*                                 */
			input.value = value ?? '';

			/*                */
			if (end !== null) {
				input.selectionStart = start;
				input.selectionEnd = Math.min(end, input.value.length);
			}
		}
	});

	if (
		/*                                                   */
		/*                                                 */
		(hydrating && input.defaultValue !== input.value) ||
		/*                                                 */
		/*                                                               */
		(untrack(get) == null && input.value)
	) {
		set(is_numberlike_input(input) ? to_number(input.value) : input.value);
	}

	render_effect(() => {
		if (DEV && input.type === 'checkbox') {
			/*                                   */
			e.bind_invalid_checkbox_value();
		}

		var value = get();

		if (is_numberlike_input(input) && value === to_number(input.value)) {
			/*                                                                        */
			return;
		}

		if (input.type === 'date' && !value && !input.value) {
			/*                                                                                                                */
			/*                                                                                                                           */
			return;
		}

		/*                                                         */
		/*                         */
		if (value !== input.value) {
			/*                                                  */
			input.value = value ?? '';
		}
	});
}

/*                                  */
const pending = new Set();

/**
 *
 *
 *
 *
 *
 *
 */
export function bind_group(inputs, group_index, input, get, set = get) {
	var is_checkbox = input.getAttribute('type') === 'checkbox';
	var binding_group = inputs;

	/*                                                                        */
	let hydration_mismatch = false;

	if (group_index !== null) {
		for (var index of group_index) {
			/*               */
			binding_group = binding_group[index] ??= [];
		}
	}

	binding_group.push(input);

	listen_to_event_and_reset_event(
		input,
		'change',
		() => {
			/*         */
			var value = input.__value;

			if (is_checkbox) {
				value = get_binding_group_value(binding_group, value, input.checked);
			}

			set(value);
		},
		/*                                 */
		() => set(is_checkbox ? [] : null)
	);

	render_effect(() => {
		var value = get();

		/*                                                                             */
		/*                      */
		if (hydrating && input.defaultChecked !== input.checked) {
			hydration_mismatch = true;
			return;
		}

		if (is_checkbox) {
			value = value || [];
			/*         */
			input.checked = value.includes(input.__value);
		} else {
			/*         */
			input.checked = is(input.__value, value);
		}
	});

	teardown(() => {
		var index = binding_group.indexOf(input);

		if (index !== -1) {
			binding_group.splice(index, 1);
		}
	});

	if (!pending.has(binding_group)) {
		pending.add(binding_group);

		queue_micro_task(() => {
			/*                                                                   */
			binding_group.sort((a, b) => (a.compareDocumentPosition(b) === 4 ? -1 : 1));
			pending.delete(binding_group);
		});
	}

	queue_micro_task(() => {
		if (hydration_mismatch) {
			var value;

			if (is_checkbox) {
				value = get_binding_group_value(binding_group, value, input.checked);
			} else {
				var hydration_input = binding_group.find((input) => input.checked);
				/*         */
				value = hydration_input?.__value;
			}

			set(value);
		}
	});
}

/**
 *
 *
 *
 *
 */
export function bind_checked(input, get, set = get) {
	listen_to_event_and_reset_event(input, 'change', (is_reset) => {
		var value = is_reset ? input.defaultChecked : input.checked;
		set(value);
	});

	if (
		/*                                                   */
		/*                                                */
		(hydrating && input.defaultChecked !== input.checked) ||
		/*                                                       */
		untrack(get) == null
	) {
		set(input.checked);
	}

	render_effect(() => {
		var value = get();
		input.checked = Boolean(value);
	});
}

/**
 *
 *
 *
 *
 *
 */
function get_binding_group_value(group, __value, checked) {
	var value = new Set();

	for (var i = 0; i < group.length; i += 1) {
		if (group[i].checked) {
			/*         */
			value.add(group[i].__value);
		}
	}

	if (!checked) {
		value.delete(__value);
	}

	return Array.from(value);
}

/**
 *
 */
function is_numberlike_input(input) {
	var type = input.type;
	return type === 'number' || type === 'range';
}

/**
 *
 */
function to_number(value) {
	return value === '' ? null : +value;
}

/**
 *
 *
 *
 */
export function bind_files(input, get, set = get) {
	listen_to_event_and_reset_event(input, 'change', () => {
		set(input.files);
	});

	render_effect(() => {
		input.files = get();
	});
}
